// extracted by mini-css-extract-plugin
export var circle = "_dt-1";
export var exitConfirmationModal = "_dt-5";
export var iframe = "_dt-0";
export var offline = "_dt-3";
export var online = "_dt-2";
export var workstationSelectError = "_dt-4";